
const Rotate = {
  Normal: 0,
  Rotate90: 90,
  Rotate180: 180,
  Rotate270: 270
};

const createImageAsync = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};


const createCanvasBlobAsync = (canvas: HTMLCanvasElement, type?: string, quality?: number): Promise<Blob> => {
  return new Promise((resolve) => {
    canvas.toBlob(
      (blob: Blob) => {
        resolve(blob);
      },
      type ?? "image/png",
      quality ?? 1
    );
  });
};

const resizeImageBlobAsync = async (
  blob: Blob,
  width: number,
  height: number,
  type?: string,
  quality?: number
) => {
  const url = URL.createObjectURL(blob);
  const image = await createImageAsync(url);
  const canvas: HTMLCanvasElement = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(image as HTMLImageElement, 0, 0, width, height);
  URL.revokeObjectURL(url);

  return await createCanvasBlobAsync(canvas, type, quality);
};

const cropImageBlobAsync = async (
  blob: Blob,
  sx: number,
  sy: number,
  sWidth: number,
  sHeight: number,
  dx: number,
  dy: number,
  dWidth: number,
  dHeight: number,
  type?: string,
  quality?: number
) => {
  const url = URL.createObjectURL(blob);
  const image = await createImageAsync(url);
  const canvas: HTMLCanvasElement = document.createElement("canvas");
  canvas.width = dWidth;
  canvas.height = dHeight;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(
    image as HTMLImageElement,
    sx,
    sy,
    sWidth,
    sHeight,
    dx,
    dy,
    dWidth,
    dHeight
  );
  URL.revokeObjectURL(url);

  return await createCanvasBlobAsync(canvas, type, quality);
};

let MovePoint = 30;

const ScreenTypeStyle = {
  Squre: 0,
  Landscape: 1,
  Portrait: 2
};

class RotateImageCanvas {
  canvas: any = document.createElement("canvas");
  originImage: HTMLImageElement;
  rotate = Rotate.Normal;
  width: number;
  height: number;
  mirrorX: boolean = false;
  mirrorY: boolean = false;

  buildImageUrlAsync = async (imgUrl: string) => {
    const image: any = await createImageAsync(imgUrl);
    this.buildImage(image);
    this.originImage = image;
  };

  buildImage = (image: HTMLImageElement) => {
    let ctx = this.canvas.getContext("2d");
    ctx.save();
    ctx.drawImage(image, 0, 0, this.width, this.height);
    ctx.restore();
    this.originImage = image;
  };

  draw = () => {
    let canvas = this.canvas;
    let ctx = this.canvas.getContext("2d");
    let image = this.originImage;

    ctx.save();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
    ctx.save();

    canvas.width = image.width;
    canvas.height = image.height;

    ctx.drawImage(image, 0, 0, image.width, image.height);
    ctx.restore();
  };

  mirrorAxisX = () => {
    this.mirrorX = !this.mirrorX;
    this._drawConverted();
  };

  mirrorAxisY = () => {
    this.mirrorY = !this.mirrorY;
    this._drawConverted();
  };

  rotate90 = () => {
    this._setNextRotate();
    this._drawConverted();
  };

  _drawConverted = () => {
    let canvas = this.canvas;
    let ctx = this.canvas.getContext("2d");
    let image = this.originImage;

    ctx.save();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
    ctx.save();

    let rotate = this.rotate;
    switch (rotate) {
      case Rotate.Normal:
        canvas.width = image.width;
        canvas.height = image.height;
        break;
      case Rotate.Rotate90:
        canvas.width = image.height;
        canvas.height = image.width;
        ctx.rotate((Math.PI / 180) * rotate);
        ctx.translate(0, -1 * image.height);
        break;
      case Rotate.Rotate180:
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.rotate((Math.PI / 180) * rotate);
        ctx.translate(-1 * image.width, -1 * image.height);
        break;
      case Rotate.Rotate270:
        canvas.width = image.height;
        canvas.height = image.width;
        ctx.rotate((Math.PI / 180) * rotate);
        ctx.translate(-1 * image.width, 0);
        break;
      default:
        break;
    }

    ctx.scale(this.mirrorX ? -1 : 1, this.mirrorY ? -1 : 1);
    ctx.drawImage(
      image,
      this.mirrorX ? -image.width : 0,
      this.mirrorY ? -image.height : 0,
      image.width,
      image.height
    );
    ctx.restore();
  };

  _setNextRotate = () => {
    switch (this.rotate) {
      case Rotate.Normal:
        this.rotate = Rotate.Rotate90;
        break;
      case Rotate.Rotate90:
        this.rotate = Rotate.Rotate180;
        break;
      case Rotate.Rotate180:
        this.rotate = Rotate.Rotate270;
        break;
      case Rotate.Rotate270:
        this.rotate = Rotate.Normal;
        break;
      default:
        break;
    }
  };

  _drawRotate = (
    ctx: CanvasRenderingContext2D,
    rotate: number,
    image: ImageBitmap
  ) => {
    switch (rotate) {
      case Rotate.Normal:
        break;
      case Rotate.Rotate90:
        ctx.rotate((Math.PI / 180) * rotate);
        ctx.translate(0, -1 * image.height);
        break;
      case Rotate.Rotate180:
        ctx.rotate((Math.PI / 180) * rotate);
        ctx.translate(-1 * image.width, -1 * image.height);
        break;
      case Rotate.Rotate270:
        ctx.rotate((Math.PI / 180) * rotate);
        ctx.translate(-1 * image.width, 0);
        break;
      default:
        break;
    }
  };
}
class ImageCanvas {
  width: number;
  height: number;
  canvas: HTMLCanvasElement = document.createElement("canvas");
  rotate: number = 0;
  screenX: number = 0;
  screenY: number = 0;
  screenWidth: number = 0;
  screenHeight: number = 0;
  zoomInStep: number = 0;
  yMove: number = 0;
  xMove: number = 0;
  // 확대 축소를 위한 용도
  screenMaxWidth: number = 500;
  screenMaxHeight: number = 500;
  isImageLoaded: boolean = false;
  screenTypeStyle: number;
  drawComplete: boolean = false;
  originImage: ImageBitmap;
  imageRotated: RotateImageCanvas;

  public static async createAsync(width: number, height: number, uri: string) {
    const canvas: ImageCanvas = new ImageCanvas(width, height);
    const img = await createImageAsync(uri);
    canvas.setImage(img);
    await canvas.drawCover(img);
    return canvas;
  }

  constructor(width: number, height: number) {
    this.width = width;
    this.height = height;
    this.canvas.width = width;
    this.canvas.height = height;

    if (width == height) {
      this.screenTypeStyle = ScreenTypeStyle.Squre;
    } else if (width > height) {
      this.screenTypeStyle = ScreenTypeStyle.Landscape;
    } else if (width < height) {
      this.screenTypeStyle = ScreenTypeStyle.Portrait;
    }
  }

  setImage = (image: any) => {
    this.originImage = image;
    this.imageRotated = new RotateImageCanvas();
    this.imageRotated.buildImage(image);
    this.imageRotated.draw();
    this.isImageLoaded = true;
  };

  drawCover = (newImage?: any) => {
    let image = newImage ? newImage : this.originImage;

    // canvas == screen
    this.screenWidth = this.width;
    this.screenHeight = this.height;
    this.screenMaxWidth = image.width;
    this.screenMaxHeight = image.height;

    // 이미지가 작을 때
    if (this.screenWidth > image.width || this.screenHeight > image.height) {
      while (this.moveZoomIn(false)) {
        if (
          this.screenWidth < image.width &&
          this.screenHeight < image.height
        ) {
          this.moveZoomOut(false);
          break;
        }
      }
      // 클 때
    } else if (
      this.screenWidth < image.width &&
      this.screenHeight < image.height
    ) {
      while (this.moveZoomOut(false)) {
        if (
          this.screenWidth > image.width ||
          this.screenHeight > image.height
        ) {
          break;
        }
      }
    }

    let ctx = this.canvas.getContext("2d");

    this._moveCenter();

    ctx.save();
    ctx.clearRect(0, 0, this.width, this.height);

    ctx.drawImage(
      image,
      this.screenX,
      this.screenY,
      this.screenWidth,
      this.screenHeight,
      0,
      0,
      this.width,
      this.height
    );

    ctx.save();
    this.drawComplete = true;
  };

  drawCover2 = (newImage: ImageBitmap) => {
    this.drawCover(newImage);
  };

  private _moveCenter = () => {
    let centerX = (this.screenMaxWidth - this.screenWidth) / 2;
    this.screenX = centerX > 0 ? centerX : 0;

    let centerY = (this.screenMaxHeight - this.screenHeight) / 2;
    this.screenY = centerY > 0 ? centerY : 0;
  };

  private _moveDownScreenY = () => {
    if (this.width < 300) MovePoint = 10;
    this._moveScreenY(-1 * MovePoint);
  };

  private _moveUpScreenY = () => {
    if (this.width < 300) MovePoint = 10;
    this._moveScreenY(MovePoint);
  };

  private _moveScreenY = (point: number, move: boolean = true) => {
    let screenY = this.screenY;
    screenY += point;
    const preScreenY = this.screenY;
    if (point <= 0) {
      this.screenY = screenY < 0 ? 0 : screenY;
    } else {
      this.screenY =
        screenY + this.screenHeight < this.screenMaxHeight
          ? screenY
          : this.screenMaxHeight - this.screenHeight;
    }
    move && (this.yMove += this.screenY - preScreenY);
  };

  private _moveLeftScreenX = () => {
    if (this.width < 300) MovePoint = 10;
    this._moveScreenX(-1 * MovePoint);
  };

  private _moveRightScreenX = () => {
    if (this.width < 300) MovePoint = 10;
    this._moveScreenX(MovePoint);
  };

  private _moveScreenX = (point: number, move = true) => {
    let screenX = this.screenX;
    screenX += point;
    const preScreenX = this.screenX;
    if (point <= 0) {
      this.screenX = screenX < 0 ? 0 : screenX;
    } else {
      this.screenX =
        screenX + this.screenWidth < this.screenMaxWidth
          ? screenX
          : this.screenMaxWidth - this.screenWidth;
    }
    move && (this.xMove += this.screenX - preScreenX);
  };

  moveDown = () => {
    switch (this.rotate) {
      case Rotate.Normal:
        this._moveDownScreenY();
        break;
      case Rotate.Rotate90:
        this._moveLeftScreenX();
        break;
      case Rotate.Rotate180:
        this._moveUpScreenY();
        break;
      case Rotate.Rotate270:
        this._moveRightScreenX();
        break;
      default:
        break;
    }

    this._drawImage();
  };

  moveUp = () => {
    switch (this.rotate) {
      case Rotate.Normal:
        this._moveUpScreenY();
        break;
      case Rotate.Rotate90:
        this._moveRightScreenX();
        break;
      case Rotate.Rotate180:
        this._moveDownScreenY();
        break;
      case Rotate.Rotate270:
        this._moveLeftScreenX();
        break;
      default:
        break;
    }
    this._drawImage();
  };

  moveRight = () => {
    switch (this.rotate) {
      case Rotate.Normal:
        this._moveLeftScreenX();
        break;
      case Rotate.Rotate90:
        this._moveUpScreenY();
        break;
      case Rotate.Rotate180:
        this._moveRightScreenX();
        break;
      case Rotate.Rotate270:
        this._moveDownScreenY();
        break;
      default:
        break;
    }
    this._drawImage();
  };

  moveLeft = () => {
    switch (this.rotate) {
      case Rotate.Normal:
        this._moveRightScreenX();
        break;
      case Rotate.Rotate90:
        this._moveDownScreenY();
        break;
      case Rotate.Rotate180:
        this._moveLeftScreenX();
        break;
      case Rotate.Rotate270:
        this._moveUpScreenY();
        break;
      default:
        break;
    }
    this._drawImage();
  };

  moveZoomIn = (isRunDraw?: boolean) => {
    let runDraw = typeof isRunDraw !== "undefined" ? isRunDraw : true;
    let zoomInSize = 5;
    if (this.width > 2000) zoomInSize = 20;
    let screenZoomPointX = this.width / zoomInSize;
    let screenZoomPointY = this.height / zoomInSize;
    let minZoomInSize = 100;
    if (this.originImage.width < 100 && this.originImage.height < 100) {
      minZoomInSize =
        this.originImage.width - screenZoomPointX <
        this.originImage.height - screenZoomPointY
          ? this.originImage.width - screenZoomPointX
          : this.originImage.height - screenZoomPointY;
    }

    if (
      this.screenWidth - screenZoomPointX <= minZoomInSize + 10 ||
      this.screenHeight - screenZoomPointY <= minZoomInSize + 10
    ) {
      return false;
    }

    if (this.screenWidth - screenZoomPointX < minZoomInSize) {
      this.screenWidth = this.screenWidth - screenZoomPointX;
    } else {
      this.screenWidth -= screenZoomPointX;
      this._moveScreenX(screenZoomPointX / 2, false);
    }

    if (this.screenHeight - screenZoomPointY < minZoomInSize) {
      this.screenHeight = this.screenHeight - screenZoomPointY;
    } else {
      this.screenHeight -= screenZoomPointY;
      this._moveScreenY(screenZoomPointY / 2, false);
    }

    if (runDraw) {
      this._drawImage();
    }
    runDraw && ++this.zoomInStep;
    return true;
  };

  moveZoomOut = (isRunDraw?: boolean) => {
    let runDraw = typeof isRunDraw !== "undefined" ? isRunDraw : true;
    let zoomOutSize = 5;
    if (this.height > 1800) zoomOutSize = 20;
    let screenZoomPointX = this.width / zoomOutSize;
    let screenZoomPointY = this.height / zoomOutSize;

    if (
      this.screenWidth + screenZoomPointX >= this.screenMaxWidth ||
      this.screenHeight + screenZoomPointY >= this.screenMaxHeight
    ) {
      let diffX = this.screenMaxWidth - this.screenWidth;
      let diffY = this.screenMaxHeight - this.screenHeight;
      if (diffX > diffY) {
        if (diffY < 0) return;
        let rateY = diffY / this.height;
        let zoomPointXAsRateY = this.width * rateY;
        this.screenHeight = this.screenMaxHeight;
        this.screenY = 0;
        this.screenWidth = this.screenWidth + zoomPointXAsRateY;
        this._moveScreenX(-1 * (zoomPointXAsRateY / 2), false);
      } else if (diffX < diffY) {
        if (diffX < 0) return;
        let rateX = diffX / this.width;
        let zoomPointYAsRateX = this.height * rateX;
        this.screenWidth = this.screenMaxWidth;
        this.screenX = 0;
        this.screenHeight = this.screenHeight + zoomPointYAsRateX;
        this._moveScreenY(-1 * (zoomPointYAsRateX / 2), false);
      } else {
        this.screenWidth = this.screenMaxWidth;
        this.screenHeight = this.screenMaxHeight;
      }

      if (this.screenX + this.screenWidth > this.imageRotated.canvas.width) {
        this.screenX = this.imageRotated.canvas.width - this.screenWidth;
      }
      if (this.screenY + this.screenHeight > this.imageRotated.canvas.height) {
        this.screenY = this.imageRotated.canvas.height - this.screenHeight;
      }

      if (runDraw) {
        this._drawImage();
      }

      runDraw && this.zoomInStep > 0 && --this.zoomInStep;
      return false;
    }

    // Zoom out
    if (this.screenWidth + screenZoomPointX < this.screenMaxWidth) {
      this.screenWidth += screenZoomPointX;
      this._moveScreenX(-1 * (screenZoomPointX / 2), false);
      if (this.screenWidth + this.screenX > this.screenMaxWidth) {
        this._moveScreenX(-1 * (screenZoomPointX / 2), false);
      }
    } else {
      this.screenWidth = this.screenMaxWidth;
      this._moveScreenX(-1 * (screenZoomPointX / 2), false);
    }

    if (this.screenHeight + screenZoomPointY < this.screenMaxHeight) {
      this.screenHeight += screenZoomPointY;
      this._moveScreenY(-1 * (screenZoomPointY / 2), false);
      if (this.screenHeight + this.screenY > this.screenMaxHeight) {
        this._moveScreenY(-1 * (screenZoomPointY / 2), false);
      }
    } else {
      this.screenHeight = this.screenMaxHeight;
      this._moveScreenY(-1 * (screenZoomPointY / 2), false);
    }
    runDraw && this.zoomInStep > 0 && --this.zoomInStep;
    if (runDraw) {
      this._drawImage();
    }
    return true;
  };

  private _drawImage = () => {
    let ctx = this.canvas.getContext("2d");
    ctx.save();
    this._drawImageFromContext(ctx);
    ctx.restore();
  };

  private _drawImageFromContext = (ctx: CanvasRenderingContext2D) => {
    ctx.clearRect(0, 0, this.width, this.height);
    ctx.drawImage(
      this.imageRotated.canvas,
      this.screenX,
      this.screenY,
      this.screenWidth,
      this.screenHeight,
      0,
      0,
      this.width,
      this.height
    );
  };

  drawRotate = (rotate: number) => {
    let ctx = this.canvas.getContext("2d");
    ctx.save();
    ctx.rotate((Math.PI / 180) * rotate);
    this.rotate = rotate;
    switch (rotate) {
      case Rotate.Normal:
        break;
      case Rotate.Rotate90:
        ctx.translate(0, this.height);
        break;
      case Rotate.Rotate180:
        ctx.translate(this.width, this.height);
        break;
      case Rotate.Rotate270:
        ctx.translate(this.width, 0);
        break;
      default:
        break;
    }

    this._drawImageFromContext(ctx);
    ctx.restore();
  };

  drawRotate90 = () => {
    this.imageRotated.rotate90();
    this._drawConverted();
  };

  mirrorAxisX = () => {
    this.imageRotated.mirrorAxisX();
    this._drawConverted();
  };

  mirrorAxisY = () => {
    this.imageRotated.mirrorAxisY();
    this._drawConverted();
  };

  _drawConverted = () => {
    let ctx = this.canvas.getContext("2d");

    ctx.save();
    ctx.clearRect(0, 0, this.width, this.height);
    this.drawCover2(this.imageRotated.canvas);
    let zoomInStep = this.zoomInStep;

    // 로테이트 되기 전에 이동값 적용
    while (zoomInStep > 0) {
      this.moveZoomIn(false);
      --zoomInStep;
    }
    const [xMove, yMove] = [this.xMove, this.yMove];

    // 좌표를 로테이트 된 이미지에 맞게 바꿔줌
    this.xMove = -1 * xMove;
    this.yMove = yMove;

    this.screenX = this.screenX + this.xMove;
    this.screenY = this.screenY + this.yMove;

    this.screenX = this.screenX < 0 ? 0 : this.screenX;
    this.screenY = this.screenY < 0 ? 0 : this.screenY;

    // 이미지가 x,y width, height 좌표값보다 작을 때 -> 사진이 잘림
    if (this.screenX + this.screenWidth > this.imageRotated.canvas.width) {
      this.screenX = this.imageRotated.canvas.width - this.screenWidth;
    }

    if (this.screenY + this.screenHeight > this.imageRotated.canvas.height) {
      this.screenY = this.imageRotated.canvas.height - this.screenHeight;
    }

    ctx.drawImage(
      this.imageRotated.canvas,
      this.screenX,
      this.screenY,
      this.screenWidth,
      this.screenHeight,
      0,
      0,
      this.width,
      this.height
    );
    ctx.restore();
  };
}

export {
  Rotate,
  createImageAsync,
  createCanvasBlobAsync,
  resizeImageBlobAsync,
  cropImageBlobAsync,
  ImageCanvas,
  RotateImageCanvas,
};
